import { isArray, without } from 'lodash';

module.exports = function () {

  var self = this;

  var queryString = [],
    currentPage = 1,
    asc = true,
    itemsPerPage = 10,
    isNewSearch = true,
    isPagingFinished = false;

  var totalPages = 0;

  var QUERY_KEY_DEFAULT = "Value";


  /*<editor-fold desc="[Not support in current Api]">*/

  //this.ItemsCount = null;

  //this.OrderBy = null;

  //this.PageIndex = null;

  //this.PageCount = null;

  //this.DisableRowCounting = null;

  /*</editor-fold desc="[Not support in current Api]">*/

  Object.defineProperty(this, 'totalPages', {
    get: function() {
      return totalPages;
    },
    enumerable: false
  });

  Object.defineProperty(this, "Page", {
    get: function () {
      return currentPage;
    },
    enumerable: true
  });

  Object.defineProperty(this, "ItemsPerPage", {
    get: function () {
      return itemsPerPage;
    },
    enumerable: true
  });

  Object.defineProperty(this, "Asc", {
    get: function () {
      return asc;
    },
    enumerable: true
  });

  Object.defineProperty(this, 'Filter', {
    get: function () {
      return queryString;
    },

    enumerable: true
  });


  Object.defineProperty(this, 'filterText', {
    get: function () {
      return self.getSearchFilterText();
    },

    enumerable: false
  });

  Object.defineProperty(this, 'isNewSearch', {
    get: function () {
      return isNewSearch
    },
    enumerable: false
  });

  Object.defineProperty(this, 'isPagingFinished', {
    get: function () {
      return isPagingFinished
    },
    enumerable: false
  });

  this.getSearchFilterText = function () {
    if (!isArray(queryString)) {
      return "";
    }

    var queryItem = queryString.find((item) => (item.key == QUERY_KEY_DEFAULT));

    return queryItem ? queryItem.value : "";
  };

  this.getFilterValue = function (key) {
    if (!key) {
      return self.getSearchFilterText();
    }

    if (!isArray(queryString)) {
      return null;
    }

    var queryItem = queryString.find((item) => (item.key == key));

    return queryItem ? queryItem.value : "";
  };

  this.setQueryString = function (query, key) {
    key = key || QUERY_KEY_DEFAULT;

    var subQueryItem = queryString.find((item) => (item.key == key));

    if (!subQueryItem && !query) {
      /*no data passed to query*/
      return self;
    }

    if (!subQueryItem && query) {
      /*new filter item*/
      queryString.push({key: key, value: query});
    } else if (!query) {
      /*remove item from filter (receive empty value for existing item)*/
      queryString = without(queryString, subQueryItem);
    } else if (query == subQueryItem.value) {
      /*filter item has the same value*/
      return self;
    } else {
      /*change filter item value*/
      subQueryItem.value = query;
    }
    self.flushWithoutFilter();
    return self;
  };

  this.nextPage = function () {
    currentPage++;
    isNewSearch = false;
    return self;
  };

  this.asc = function () {
    if (asc) return self;
    self.flush();
    asc = true;
    return self;
  };

  this.desc = function () {
    if (!asc) return self;
    self.flush();
    asc = false;
    return self;
  };

  this.itemsPerPage = function (itemsCount) {
    if (itemsCount == itemsPerPage) return self;
    self.flush();
    itemsPerPage = itemsCount;
    return self;
  };

  this.toDataObject = function () {
    var dataObject = {};

    for (var i in self) {
      if (!self.hasOwnProperty(i) || typeof self[i] === "function") continue;
      dataObject[i] = self[i];
    }

    return dataObject;
  };

  this.lastPagingResponse = function (pagingResponse) {
    if (!pagingResponse) return;
    totalPages = pagingResponse.pageCount;
    isPagingFinished = totalPages <= currentPage;
  };

  this.flush = function () {
    queryString = [];
    self.flushWithoutFilter();
    return self;
  };

  this.flushWithoutFilter = function () {
    currentPage = 1;
    asc = true;
    //itemsPerPage = 10;
    isNewSearch = true;
    isPagingFinished = false;
    totalPages = 0;
    return self;
  };

};
